import React from 'react'
import PageHeader from '../components/PageHeader';
import Packages from '../components/Packages';
import AllPackages from '../components/AllPackages';


const TourPackages = () => {
    return (
        <>  
            <PageHeader
                title="Our Packages"
                image="img/subscribe-img.jpg" // Use your own path
                breadcrumbs={[
                    { label: "Packages", active: true },
                ]}
            />

            <AllPackages />
        </>
    );
}

export default TourPackages